import { FC } from 'react';
import { AudioPlayer, AudioPlayerType } from '@nextgen-web-framework/all';
import type { AudioPlayerPropTypes } from '@nextgen-web-framework/all';
import { AudioPlayerContainerProptypes } from './types/propsTypes';

const AudioPlayerContainer: FC<AudioPlayerContainerProptypes> = (props: AudioPlayerContainerProptypes) => {
  const { audioFile } = props;
  const customProps: AudioPlayerPropTypes = {
    srcList: [
      {
        src: audioFile.url as unknown as string,
        type: AudioPlayerType.MP3,
      },
    ],
    trackConfig: {},
  };

  return <AudioPlayer {...customProps} controlsList="nodownload noplaybackrate" />;
};

export default AudioPlayerContainer;
